import log from "loglevel";
import { contactBackend } from "./apiHelpers";
import { Theme } from "./store/features/themeSlice";
import { WebchatFeatureSyncDoc } from "./store/features/webchatFeatureConfigSlice";

export const configDataHandler = {
  async getConfigData(): Promise<WebchatFeatureSyncDoc> {
    try {
      const data = await contactBackend<WebchatFeatureSyncDoc>(
        `${process.env.REACT_APP_SERVER_URL}`,
        "/web-chat-configuration.json",
        "GET"
      );
      log.debug("configDataHandler: getting web chat config sync doc");
      return data;
    } catch (e) {
      log.log(
        "configDataHandler: Error to handle API to get webChat config doc"
      );
      throw Error("No results from server");
    }
  },

  async getSyncToken(): Promise<string> {
    try {
      const data = await contactBackend<{ token: string }>(
        `${process.env.REACT_APP_SERVER_URL}`,
        "/getSyncToken",
        "GET"
      );
      log.debug("configDataHandler: getting Sync Token");
      return data.token;
    } catch (e) {
      log.log("configDataHandler: Error to handle API to get syncToken");
      throw Error("No results from server");
    }
  },

  async getConfigStyle(): Promise<Theme> {
    if (process.env.REACT_APP_BUILD_NOW_URL) {
      try {
        const data = await contactBackend<Theme>(
          `${process.env.REACT_APP_BUILD_NOW_URL}`,
          "/getStylingConfig",
          "GET"
        );
        log.debug(
          "configDataHandler: getting style config sync doc from buildNow"
        );
        return data;
      } catch (e) {
        log.log(
          "configDataHandler: Error to handle API to get buildNow style config doc"
        );
        throw Error("No results from server");
      }
    } else {
      return {
        default: "light",
      };
    }
  },
};
